module.exports = function() {
  return new Worker(__webpack_public_path__ + "4cf56fd4be2e261d76f5.worker.js");
};